import React, { FunctionComponent } from 'react';

import styles from './index.module.scss';

/*
    BLOCK: delimiter
    PARAMS:
    EXAMPLE:
    {
        "type" : "delimiter",
        "data" : {}
    }
 */

type DelimiterRendererProps = {};

export const DelimiterRenderer: FunctionComponent<
DelimiterRendererProps
> = () => (
    <div className={styles.marks_container}>
        <div className={styles.marks} />
    </div>
);
